import React, { useContext, useState } from 'react';
import ProductList from '../components/ProductList/ProductList';
import SearchBar from '../components/SearchBar/SearchBar';
import ShoppingCart from '../components/ShoppingCart/ShoppingCart';
import AppContext from '../context/AppContext';
import PageController from '../components/PageController/PageController';

function Home() {
  const { filtredList, listIndex, setListIndex, listSize, setListSize } = useContext(AppContext);

  const numPages = Math.ceil(filtredList.length / listSize);

  return (
    <div className="page-container">
      <SearchBar />
      {/* <BannerPromo /> */}
      <ProductList listIndex={listIndex} listSize={listSize}/>
      <PageController listIndex={listIndex} numPages={numPages} setListIndex={setListIndex}/>
      <ShoppingCart />
    </div>
  )
}

export default Home;
